import { Heading } from "@chakra-ui/react";
import React from "react";

const ErrorText = () => {
  return (
    <Heading size="md" textAlign="center">
      Something went wrong. <br />
      Please try later
    </Heading>
  );
};

export default ErrorText;
